import React from 'react'
import './FAQ.css'
import { Typography, Collapse, Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { trackButtonClick } from '../../../../utils/gtmUtils'

const { Title, Paragraph } = Typography

interface FAQProps {
    onContactUsClick: () => void
}

const FAQ: React.FC<FAQProps> = ({ onContactUsClick }) => {
    const { t } = useTranslation()
    const faqItems = t('faq.items', { returnObjects: true }) as Array<{
        question: string
        answer: string
    }>

    return (
        <div className="faq-container" id="faq">
            <Title className="title" level={2}>
                {t('home.faq.title')}
            </Title>

            <div className="faq-content">
                {faqItems.map((faqItem, index: number) => (
                    <Collapse
                        key={`faq-${index + 1}`}
                        className="faq-collapse"
                        expandIconPosition="end"
                        items={[
                            {
                                key: `faq-${index + 1}`,
                                label: faqItem.question,
                                children: (
                                    <Paragraph style={{ marginBottom: 0 }}>
                                        {faqItem.answer}
                                    </Paragraph>
                                ),
                            },
                        ]}
                    />
                ))}

                {/* More questions CTA */}
                <div className="more-questions-cta">
                    <Title className="title" level={4}>
                        {t('home.faq.moreQuestions')}
                    </Title>
                    <Button
                        type="primary"
                        size="large"
                        onClick={() => {
                            trackButtonClick('contact_us', 'faq')
                            onContactUsClick()
                        }}
                    >
                        {t('home.faq.contactUs')}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default FAQ
